/**
 * Button
 * Primary and secondary button variants using OPOS brand colors.
 */
export default function Button({
    children,
    onClick,
    type     = 'button',
    variant  = 'primary',
    disabled = false,
    loading  = false,
    fullWidth = true,
    className = ''
}) {
    const base = `flex items-center justify-center rounded-lg font-semibold text-sm transition-all duration-150 ${fullWidth ? 'w-full' : ''} ${className}`;

    const styles = {
        primary: {
            background : disabled || loading ? '#a8e8cf' : '#2ECC8E',
            color      : 'white',
            border     : 'none',
            height     : '44px',
            cursor     : disabled || loading ? 'not-allowed' : 'pointer'
        },
        secondary: {
            background : 'white',
            color      : '#1B2F7E',
            border     : '1px solid #c5dff0',
            height     : '40px',
            cursor     : disabled ? 'not-allowed' : 'pointer'
        }
    };

    return (
        <button
            type={type}
            onClick={onClick}
            disabled={disabled || loading}
            className={base}
            style={styles[variant]}
            aria-busy={loading}
        >
            {loading ? (
                <span className="flex items-center gap-2">
                    <svg className="animate-spin" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                        <circle cx="12" cy="12" r="10" strokeOpacity="0.3" />
                        <path d="M12 2a10 10 0 0 1 10 10" />
                    </svg>
                    {typeof children === 'string' ? children : 'Loading…'}
                </span>
            ) : children}
        </button>
    );
}
